import { cloneElement, useEffect, useRef, memo, useState } from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var LinearGradientWrap = function LinearGradientWrap(_ref) {
  var children = _ref.children,
      _ref$colors = _ref.colors,
      colors = _ref$colors === undefined ? [] : _ref$colors,
      _ref$deg = _ref.deg,
      deg = _ref$deg === undefined ? 90 : _ref$deg;

  var division = 100 / (colors.length - 1);
  var distributeColor = function distributeColor(color, index) {
    return color + ' ' + index * division + '%';
  };
  var colorsString = [deg + 'deg'].concat(toConsumableArray(colors.map(distributeColor)));
  var styles = _extends({}, children.props.style, {
    backgroundImage: 'linear-gradient(' + colorsString.join(', ') + ')'
  });
  return cloneElement(children, _extends({}, children.props, { style: styles }));
};

function useInterval(callback, delay) {
  var savedCallback = useRef();

  // Remember the latest callback.
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(function () {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

var CD = memo(function (_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === undefined ? false : _ref$active,
      _ref$time = _ref.time,
      time = _ref$time === undefined ? 0 : _ref$time,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === undefined ? 1000 : _ref$timeout,
      _ref$onTick = _ref.onTick,
      onTick = _ref$onTick === undefined ? function () {
    return null;
  } : _ref$onTick,
      _ref$onFinish = _ref.onFinish,
      onFinish = _ref$onFinish === undefined ? function () {
    return null;
  } : _ref$onFinish,
      _ref$children = _ref.children,
      children = _ref$children === undefined ? null : _ref$children,
      _ref$stop = _ref.stop,
      stop = _ref$stop === undefined ? false : _ref$stop,
      _ref$startedAt = _ref.startedAt;

  var _useState = useState(0),
      _useState2 = slicedToArray(_useState, 2),
      elapsedTime = _useState2[0],
      setElapsedTime = _useState2[1];

  var remainingTime = time - elapsedTime / 1000;
  var isActive = active && remainingTime > 0 ? timeout : null;

  useInterval(function () {
    if (!stop) {
      onTick(Math.max(remainingTime - timeout / 1000, 0));
      setElapsedTime(elapsedTime + timeout);
    }
  }, isActive);

  var hasFinished = useRef(false);
  useEffect(function () {
    if (isActive === null) {
      hasFinished.current || onFinish();
      hasFinished.current = true;
    }
  }, [isActive]);

  return children;
});

var LinearGradientWrap$1 = LinearGradientWrap;
var Countdown = CD;

var index = {
  Countdown: Countdown,
  LinearGradientWrap: LinearGradientWrap$1
};

export default index;
export { LinearGradientWrap$1 as LinearGradientWrap, Countdown };
//# sourceMappingURL=index.es.js.map
